package com.sddamico.swigmore.util

import com.sddamico.swigmore.models.PollRules
import kotlin.js.Date

/** Epoch ms [at] formatted in the league's time zone with `Intl.DateTimeFormat` [options]. */
private fun pacific(at: Long, vararg options: Pair<String, String>): String = inZone(PollRules.TIME_ZONE, at, *options)

private fun inZone(zone: String, at: Long, vararg options: Pair<String, String>): String {
  val o: dynamic = js("({})")
  o.timeZone = zone
  options.forEach { (k, v) -> o[k] = v }
  return Date(at.toDouble()).asDynamic().toLocaleString("en-US", o) as String
}

/** "9:14 PM" */
fun clockTime(at: Long) = pacific(at, "hour" to "numeric", "minute" to "2-digit")

/** "Tue 9:14 PM" */
fun shortDayTime(at: Long) = pacific(at, "weekday" to "short", "hour" to "numeric", "minute" to "2-digit")

/** "Friday 12:00 PM" */
fun longDayTime(at: Long) = pacific(at, "weekday" to "long", "hour" to "numeric", "minute" to "2-digit")

/** "Oct 16" */
fun monthDay(at: Long) = pacific(at, "month" to "short", "day" to "numeric")

/** "Fri, Oct 16" */
fun shortDate(at: Long) = pacific(at, "weekday" to "short", "month" to "short", "day" to "numeric")

/** "Friday, October 16" */
fun longDate(at: Long) = pacific(at, "weekday" to "long", "month" to "long", "day" to "numeric")

/** "Friday 11:00 PM ET": the ballot deadline is set and stated in Eastern. */
fun deadlineTime(at: Long) =
  "${inZone(PollRules.EASTERN_TIME_ZONE, at, "weekday" to "long", "hour" to "numeric", "minute" to "2-digit")} ET"

/** "Fri 6:00 PM" in Eastern, for times on the deadline's schedule. */
fun easternShortDayTime(at: Long) =
  inZone(PollRules.EASTERN_TIME_ZONE, at, "weekday" to "short", "hour" to "numeric", "minute" to "2-digit")

/** The hour of day, 0–23, in Eastern. */
fun easternHour(at: Long) = inZone(PollRules.EASTERN_TIME_ZONE, at, "hour" to "numeric", "hourCycle" to "h23").toInt()
